module.exports = __webpack_public_path__ + "img/no-op-reports.a9e86b1c.svg";